<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col sm="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmuserdatasalesopportunity.list.name') }}:</label>
            <input v-model.lazy="filters.title" v-debounce="delay" class="form-control" type="text" placeholder="">
          </div>
        </b-col>
        <b-col sm="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmuserdatasalesopportunity.list.description') }}:</label>
            <input v-model.lazy="filters.description" v-debounce="delay" class="form-control" type="text" placeholder="">
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.userdata.list.filters.state') }}:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="filters.state"
                :options="radioOptions"
                buttons
                button-variant="outline-primary"
                name="radios-btn-default"
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import debounce from 'v-debounce'
import addParamsToQuery from '@/utils/addParamsToQuery'
export default {
  name: 'UserDataSalesOpportunityFiltering',
  props: {
    url: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      radioOptions: [
        {
          value: 1,
          text: this.$t('buttons.no')
        },
        {
          value: 0,
          text: this.$t('buttons.yes')
        }
      ],
      delay: 500,
      filters: {
        title: '',
        description: '',
        state: 1
      },
      loading: false
    }
  },

  directives: {
    debounce
  },

  watch: {
    filters: {
      deep: true,
      handler () {
        this.getPage(addParamsToQuery(this.url, this.filters))
      }
    }
  },
  methods: {
    getPage (url) {
      this.$emit('getPage', url)
    }
  }
}
</script>
